module.exports = __webpack_public_path__ + "static/gira-sans-light-italic-a247bf724a0704dceba786cb0ee655ee.woff";